import React, { useState, useEffect } from "react";

import blank from "../../assets/loading.webp";
import PulseLoader from "react-spinners/PulseLoader";

type ImageState = "placeholder" | "lowQuality" | "highQuality";

interface LazyImageProps {
	lowQualitySrc: string;
	highQualitySrc?: string;
	alt: string;
	[key: string]: unknown; // Allow any additional props for the img element
}

function LazyImage({
	lowQualitySrc,
	highQualitySrc,
	alt,
	...rest
}: LazyImageProps) {
	const [imageState, setImageState] = useState<ImageState>("placeholder");

	useEffect(() => {
		const lowQualityImg = new Image();
		lowQualityImg.src = lowQualitySrc;
		lowQualityImg.onload = () => {
			setImageState("lowQuality");

			if (highQualitySrc) {
				const highQualityImg = new Image();
				highQualityImg.src = highQualitySrc;
				highQualityImg.onload = () => {
					setImageState("highQuality");
				};
			}
		};

		// Clean up function to avoid setting state if component is unmounted
		return () => {
			lowQualityImg.onload = null;
			if (highQualitySrc) {
				const highQualityImg = new Image();
				highQualityImg.onload = null;
			}
		};
	}, [lowQualitySrc, highQualitySrc]);

	const currentSrc =
		imageState === "highQuality"
			? highQualitySrc
			: imageState === "lowQuality"
				? lowQualitySrc
				: null;

	return (
		<div className="relative w-full">
			{imageState === "placeholder" && (
				<div className="rounded-t-xl p-8 h-56 w-full flex justify-center items-center">
					<PulseLoader />
				</div>
			)}
			{currentSrc && (
				<img
					src={currentSrc}
					alt={alt}
					style={{
						// filter:
						// 	imageState === "lowQuality" ? "blur(2px)" : "none",
						transition: "filter 0.3s ease-in-out",
					}}
					{...rest} // Spread additional props (e.g., className)
				/>
			)}
		</div>
	);
}

export default LazyImage;
